export const QUERY_KEYS = {
  mileageList: 'mileageList',
  submittedMileage: 'submittedMileage',
  isAppliedScholarship: 'isAppliedScholarship',
  scholarshipDuration: 'scholarshipDuration',
  etcMileageList: 'etcMileageList',
  userInfo: 'userInfo',
  capability: 'capability',
  semesterCapability: 'semesterCapability',
};
